import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CloneParticipantDocument } from '../mutations/cloneParticipantDocument.mutation';
import {
  CloneParticipantDocumentMutation,
  CloneParticipantDocumentMutationVariables,
} from '../types';

export const useCloneParticipantDocumentMutation = (
  options?: MutationOptions<
    CloneParticipantDocumentMutation,
    CloneParticipantDocumentMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CloneParticipantDocument), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
